module.exports = __webpack_public_path__ + "media/jungle-background.766d0de5.mp3";